import { createI18n } from 'vue-i18n'
import en from './en.json'
import nl from './nl.json'

const messages = {
  en: en,
  nl: nl
}

const i18n = createI18n({
  legacy: false,
  locale: 'nl',
  fallbackLocale: 'nl',
  messages
})

export default i18n